import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiLoginForgotpasswordMutationRequest,
  PostApiLoginForgotpasswordMutationResponse,
} from "../../../types/PostApiLoginForgotpassword";

export function getPostApiLoginForgotpasswordUrl() {
  return `/api/Login/ForgotPassword` as const;
}

/**
 * {@link /api/Login/ForgotPassword}
 */
export async function postApiLoginForgotpassword(
  data?: PostApiLoginForgotpasswordMutationRequest,
  config: Partial<RequestConfig<PostApiLoginForgotpasswordMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiLoginForgotpasswordMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiLoginForgotpasswordMutationRequest
  >({
    method: "POST",
    url: getPostApiLoginForgotpasswordUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
